import React from "react";
import { Icon, IconProps } from "./Icon"; // Import the generic Icon component

export const StarFilled = (props: IconProps) => {
  return (
    <Icon
      classes={props.classes}
      height="24px"
      width="24px"
      viewBox="0 -960 960 960"
    >
      <path d="m233-120 65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z" />
    </Icon>
  );
};
